module.exports = __webpack_public_path__ + "img/activity-empty.cf56d77c.png";